import { AGE_BAND_VARIABLE } from '@components/storeMap/dataAge'
import MarkedShelf from '@components/storeMap/floor/2d/MarkedShelf'
import { ageBandOf } from '@state/shelf/transformations/dayState'

import type { ShelfProps } from './Shelf'

function AgeShelf({ shelf, ...props }: ShelfProps) {
  const fill = shelf.daysBeforeDay === undefined ? undefined : `var(${AGE_BAND_VARIABLE[ageBandOf(shelf.daysBeforeDay)]})`

  // the lightest band needs the border to stand out from the floor
  return <MarkedShelf shelf={shelf} fill={fill} stroke='var(--color-shelf-border)' {...props} />
}

export default AgeShelf
